import React, { useEffect, useCallback, useState} from 'react';
import {FIGURE} from './constants.js';
import Screen from './Screen.js';
import {connect} from 'react-redux';

const CoreJakiComponent = ({effect, setOverflow, _figures}) => { 
    let [chosen, setChosen] = useState(undefined);
    let [figures, setFigures] = useState(_figures);

    const addFigure = useCallback(() => {
        effect.figures.newFigure();
        setFigures(effect.figures._figures);
    }, [effect, setFigures]);

    useEffect(() => {
        if (figures && _figures && figures.length !== _figures.length) {
            setChosen(undefined);
            setOverflow(undefined);
        }
        setFigures(figures);
    }, [figures, _figures, setFigures]);

    if (!effect) {
        return 0;
    }

    return (
        <div className="core-jaki jaki">
          <div className="name">Jaki</div>
          <div className="core-figures">
            {effect.figures.figures.map(f => <div 
                                onClick={() => {
                                    if (chosen && chosen.type === FIGURE && chosen.figure === f) {
                                        setOverflow(false);
                                        setChosen(undefined);
                                    } else {
                                        setChosen({
                                            type: FIGURE,
                                            figure: f
                                        });
                                        setOverflow(true);
                                    }
                                    
                                }}
                                className={chosen && chosen.figure === f ? "selected fig" : "fig"}>{f.figureLength}</div>)}
            <div onClick={addFigure} className="fig add-fig">
              +
            </div>
          </div>
          {chosen && <Screen setChosen={setChosen} chosen={chosen} effect={effect}/>}
        </div>
    );
};

const mapStateToProps = (state, props) => {
  return {
      _figures: props.effect && props.effect.figures._figures
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CoreJakiComponent);
